export const PREFIX_URL = '/clientes';
export const generateURL = (url: string) => `${PREFIX_URL}${url}`;
